import { AssetTypeRepository } from '@telespot/domain';

export interface ICountAssetTypesQuery {
  /**
   * Counts asset types matching an optional search term.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(searchTerm?: string): Promise<number>;
}

export class CountAssetTypesQuery implements ICountAssetTypesQuery {
  constructor(private readonly assetTypeRepository: AssetTypeRepository) {}

  public async execute(searchTerm?: string): Promise<number> {
    return this.assetTypeRepository.count(searchTerm);
  }
}
